module.exports = __webpack_public_path__ + "b3587bfab524d62a9252d8b8c41c3f26.svg";